import { UserState } from "../oraPrenotaStore";

export const selectRole = (state: UserState) => state.role;
